<div class="card mb-4 overflow-hidden d-none d-md-flex">
  <div class="d-flex justify-content-between">
    <h5 class="title">
      Transaction Summary
      <span *ngIf="!makingAnApiCall" class="badge bg-danger ms-2">{{ getSummaryFilterOption(filterOption).text }}</span>
      <span *ngIf="makingAnApiCall" class="spinner-grow spinner-grow-sm ms-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </span>
    </h5>
    <div class="dropdown">
      <button
        class="dropdown-toggle btn btn-outline-secondary btn-sm" type="button" id="dropdownMenuButton"
        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
      >
        <i class="fa fa-bars"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
        <a *ngFor="let option of summaryFilterOptions" (click)="fetchStats(option.id)" class="dropdown-item cursor-pointer">
          {{option.text}}
        </a>
      </div>
    </div>
  </div>
  <div class="w-100">
    <swiper [slidesPerView]="1" [spaceBetween]="10" navigation>
      <ng-template swiperSlide>
        <div class="row">
          <div class="col-6">
            <div class="card outlined p-0 mb-3 shadow-sm d-flex flex-column align-items-stretch justify-content-center text-center">
              <div class="p-4 py-5 d-flex flex-column">
                <span class="icon-cus mb-1 text-danger"><i class="fas fa-tags"></i></span>
                <span class="d-price mt-3">
                  {{ merchantDashBoardData?.total_sales_amount | currency:'NGN':'₦':'0.0' }}
                </span>
                <div class="text-center mt-2">
                  <div>Total Sales</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card outlined p-0 mb-3 shadow-sm d-flex flex-column align-items-stretch justify-content-center text-center">
              <div class="p-4 py-5 d-flex flex-column">
                <span class="icon-cus mb-1 text-primary"><i class="fas fa-credit-card"></i></span>
                <span class="d-price mt-3">
                  {{ merchantDashBoardData?.total_credit_orders_amount | currency:'NGN':'₦':'0.0' }}
                </span>
                <div class="text-center mt-2">
                  <div>Total Credit</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card outlined p-0 mb-3 shadow-sm d-flex flex-column align-items-stretch justify-content-center text-center">
              <div class="p-4 py-5 d-flex flex-column">
                <span class="icon-cus mb-1 text-success"><i class="fas fa-users"></i></span>
                <span class="d-price mt-3">
                  {{ merchantDashBoardData?.customer_count ? merchantDashBoardData?.customer_count : '0' }}
                </span>
                <div class="text-center mt-2">
                  <div>Customers</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card outlined p-0 mb-3 shadow-sm d-flex flex-column align-items-stretch justify-content-center text-center">
              <div class="p-4 py-5 d-flex flex-column">
                <span class="icon-cus mb-1 text-warning"><i class="fas fa-shopping-bag"></i></span>
                <span class="d-price mt-3">
                  {{ merchantDashBoardData?.orders_count ? merchantDashBoardData?.orders_count : '0' }}
                </span>
                <div class="text-center mt-2">
                  <div>Orders</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template swiperSlide>
        <div class="row">
          <div class="col-6">
            <div class="card outlined p-0 mb-3 shadow-sm d-flex flex-column align-items-stretch justify-content-center text-center">
              <div class="p-4 py-5 d-flex flex-column">
                <span class="icon-cus mb-1 text-danger"><i class="fas fa-cart-arrow-down"></i></span>
                <span class="d-price mt-3">
                  {{ merchantDashBoardData?.total_credit_orders_amount | currency:'NGN':'₦':'0.0' }}
                </span>
                <div class="text-center mt-2">
                  <div>Credit Orders</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card outlined p-0 mb-3 shadow-sm d-flex flex-column align-items-stretch justify-content-center text-center">
              <div class="p-4 py-5 d-flex flex-column">
                <span class="icon-cus mb-1 text-primary"><i class="fas fa-thumbs-up"></i></span>
                <span class="d-price mt-3">
                  {{ merchantDashBoardData?.total_likes ? merchantDashBoardData?.total_likes : '0' }}
                </span>
                <div class="text-center mt-2">
                  <div>Total Likes</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card outlined p-0 mb-3 shadow-sm d-flex flex-column align-items-stretch justify-content-center text-center">
              <div class="p-4 py-5 d-flex flex-column">
                <span class="icon-cus mb-1 text-success"><i class="fas fa-comment"></i></span>
                <span class="d-price mt-3">
                  {{ merchantDashBoardData?.total_comments ? merchantDashBoardData?.total_comments : '0' }}
                </span>
                <div class="text-center mt-2">
                  <div>Comments</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card outlined p-0 mb-3 shadow-sm d-flex flex-column align-items-stretch justify-content-center text-center">
              <div class="p-4 py-5 d-flex flex-column">
                <span class="icon-cus mb-1 text-warning"><i class="fas fa-eye"></i></span>
                <span class="d-price mt-3">
                  {{ merchantDashBoardData?.total_views ? merchantDashBoardData?.total_views : '0' }}
                </span>
                <div class="text-center mt-2">
                  <div>Total Views</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </swiper>
  </div>
</div>

<div class="mb-4 d-md-none">
  <swiper [slidesPerView]="1.2" [spaceBetween]="10">
    <ng-template swiperSlide>
      <div (click)="modal = 'filter'" class="card bg-primary text-white d-flex flex-row align-items-center">
        <div class="icon" style="font-size: 3rem;"><i class="fa fa-tags"></i></div>
        <div class="ms-auto">
          <div class="h2 stat-value fw-bold text-white mb-1 text-ellipsize small-currency" style="max-width: 180px;">
            <small>₦</small> {{ (merchantDashBoardData?.total_sales_amount || 0) | shortenNumber }}
          </div>
          <small>Total sales</small>
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide>
      <div (click)="modal = 'filter'" class="card bg-danger text-white d-flex flex-row align-items-center">
        <div class="icon" style="font-size: 3rem;"><i class="fa fa-credit-card"></i></div>
        <div class="ms-auto">
          <div class="h2 stat-value fw-bold text-white mb-1 small-currency" style="max-width: 180px;">
            <small>₦</small> {{ (merchantDashBoardData?.total_credit_orders_amount || 0) | shortenNumber }}
          </div>
          <small>Total credit</small>
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide>
      <div (click)="modal = 'filter'" class="card bg-warning text-white d-flex flex-row align-items-center">
        <div class="icon" style="font-size: 3rem;"><i class="fa fa-users"></i></div>
        <div class="ms-auto">
          <div class="h2 stat-value fw-bold text-white mb-1 text-ellipsize" style="max-width: 180px;">
            {{ merchantDashBoardData?.customer_count || 0 }}
          </div>
          <small>Customers</small>
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide>
      <div (click)="modal = 'filter'" class="card bg-info text-white d-flex flex-row align-items-center">
        <div class="icon" style="font-size: 3rem;"><i class="fa fa-cart-arrow-down"></i></div>
        <div class="ms-auto">
          <div class="h2 stat-value fw-bold text-white mb-1 text-ellipsize" style="max-width: 180px;">
            {{ merchantDashBoardData?.orders_count || 0 }}
          </div>
          <small>Orders</small>
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide>
      <div (click)="modal = 'filter'" class="card bg-warning text-white d-flex flex-row align-items-center">
        <div class="icon" style="font-size: 3rem;"><i class="fa fa-luggage-cart"></i></div>
        <div class="ms-auto">
          <div class="h2 stat-value fw-bold text-white mb-1 text-ellipsize small-currency" style="max-width: 180px;">
            <small>₦</small>{{ merchantDashBoardData?.total_credit_orders_amount | shortenNumber }}
          </div>
          <small>Credit orders</small>
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide>
      <div (click)="modal = 'filter'" class="card bg-danger text-white d-flex flex-row align-items-center">
        <div class="icon" style="font-size: 3rem;"><i class="fa fa-heart"></i></div>
        <div class="ms-auto">
          <div class="h2 stat-value fw-bold text-white mb-1 text-ellipsize" style="max-width: 180px;">
            {{ merchantDashBoardData?.total_likes ? merchantDashBoardData?.total_likes : '0' }}
          </div>
          <small>Total likes</small>
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide>
      <div (click)="modal = 'filter'" class="card bg-primary text-white d-flex flex-row align-items-center">
        <div class="icon" style="font-size: 3rem;"><i class="fa fa-comments"></i></div>
        <div class="ms-auto">
          <div class="h2 stat-value fw-bold text-white mb-1 text-ellipsize" style="max-width: 180px;">
            {{ merchantDashBoardData?.total_comments ? merchantDashBoardData?.total_comments : '0' }}
          </div>
          <small>Comments</small>
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide>
      <div (click)="modal = 'filter'" class="card bg-warning text-white d-flex flex-row align-items-center">
        <div class="icon" style="font-size: 3rem;"><i class="fa fa-binoculars"></i></div>
        <div class="ms-auto">
          <div class="h2 stat-value fw-bold text-white mb-1 text-ellipsize" style="max-width: 180px;">
            {{ merchantDashBoardData?.total_views ? merchantDashBoardData?.total_views : '0' }}
          </div>
          <small>Total views</small>
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide>
      <div (click)="modal = 'filter'" class="card bg-danger text-white d-flex flex-row align-items-center">
        <div class="icon" style="font-size: 3rem;"><i class="fa fa-filter"></i></div>
        <div class="ms-auto">
          <div class="h2 stat-value fw-bold text-white mb-1 text-ellipsize" style="max-width: 180px;">Filter</div>
          <small>Click to change filter</small>
        </div>
      </div>
    </ng-template>
  </swiper>
</div>

<app-dialog *ngIf="modal === 'filter'" (close)="modal = ''" [close-button]="false" title="Filter stats">
  <ul class="list-group list-group-flush" aria-labelledby="dropdownMenuButton">
    <li class="list-group-item px-0 py-2 d-flex justify-content-between align-items-center">
      <a (click)="fetchStats('1')" class="btn btn-link px-0">Today</a>
      <i class="fa fa-arrow-right text-muted"></i>
    </li>
    <li class="list-group-item px-0 py-2 d-flex justify-content-between align-items-center">
      <a (click)="fetchStats('2')" class="btn btn-link px-0">Last 24 hours</a>
      <i class="fa fa-arrow-right text-muted"></i>
    </li>
    <li class="list-group-item px-0 py-2 d-flex justify-content-between align-items-center">
      <a (click)="fetchStats('3')" class="btn btn-link px-0">Yesterday</a>
      <i class="fa fa-arrow-right text-muted"></i>
    </li>
    <li class="list-group-item px-0 py-2 d-flex justify-content-between align-items-center">
      <a (click)="fetchStats('4')" class="btn btn-link px-0">Last 7 days</a>
      <i class="fa fa-arrow-right text-muted"></i>
    </li>
    <li class="list-group-item px-0 py-2 d-flex justify-content-between align-items-center">
      <a (click)="fetchStats('6')" class="btn btn-link px-0">This Week</a>
      <i class="fa fa-arrow-right text-muted"></i>
    </li>
    <li class="list-group-item px-0 py-2 d-flex justify-content-between align-items-center">
      <a (click)="fetchStats('7')" class="btn btn-link px-0">This Month</a>
      <i class="fa fa-arrow-right text-muted"></i>
    </li>
    <li class="list-group-item px-0 py-2 d-flex justify-content-between align-items-center">
      <a (click)="fetchStats('5')" class="btn btn-link px-0">Last 30 days</a>
      <i class="fa fa-arrow-right text-muted"></i>
    </li>
    <li class="list-group-item px-0 py-2 d-flex justify-content-between align-items-center">
      <a (click)="fetchStats('8')" class="btn btn-link px-0">This Year</a>
      <i class="fa fa-arrow-right text-muted"></i>
    </li>
    <li class="list-group-item px-0 py-2 d-flex justify-content-between align-items-center">
      <a (click)="fetchStats('9')" class="btn btn-link px-0">Lifetime</a>
      <i class="fa fa-arrow-right text-muted"></i>
    </li>
  </ul>
</app-dialog>
